import React, {memo} from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useTranslation} from 'react-i18next';
import {usePostApiDispatch} from 'common/hooks/usePostApiDispatch';
import api from 'api';
import {NameDialog} from 'components/dialogs/NameDialog';
import {DialogTypes} from 'common/names';
import {folderTypes} from 'redux/folders';

interface Props {
   onClose: () => void;
   data: INav;
}
const FolderAddDialog = memo(({data, onClose}: Props) => {
   const {t} = useTranslation();
   const createNode = usePostApiDispatch(`${api.folders}/${data.id}`, folderTypes.ADD_SUB_FOLDER);

   if (!data.addable) {
      return null;
   }

   return (
      <>
         <NameDialog
            title={DialogTypes.FolderAddDialog.dialogName}
            label={t('New Folder Name')}
            onClose={(obj) => {
               obj && createNode({folderName: obj.name});
               onClose();
            }}
         />
      </>
   );
});

export default FolderAddDialog;
